import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";

const EditableLabel = ({
  initialValue,
  onEditComplete,
  initialEditability = false
}) => {
  const [newValue, setNewValue] = React.useState(initialValue);
  const [editValue, setEditValue] = React.useState(initialEditability);
  const onBlur = (value, updateComplete) => {
    setNewValue(value);
    setEditValue(false);
    if (updateComplete && value !== initialValue) {
      onEditComplete(value);
    }
  };
  React.useEffect(() => {
    setEditValue(initialEditability);
  }, [initialEditability]);
  return (
    <>
      {!editValue && <span onClick={() => setEditValue(true)}>{newValue}</span>}
      {editValue && (
        <TextField
          value={newValue}
          onChange={ev => setNewValue(ev.target.value)}
          margin="normal"
          variant="filled"
          autoFocus
          onKeyPress={ev => {
            if (ev.key === "Enter") {
              ev.target.blur();
              ev.preventDefault();
            }
          }}
          onClick={ev => {
            ev.stopPropagation();
          }}
          onBlur={ev => {
            onBlur(ev.target.value, true);
            ev.preventDefault();
          }}
          hiddenLabel
        />
      )}
    </>
  );
};

EditableLabel.propTypes = {
  initialValue: PropTypes.string,
  onEditComplete: PropTypes.func,
  initialEditability: PropTypes.bool
};

export default EditableLabel;
